import Vue from 'vue'

const state = {
  currentEntity: null,
  currentEntityProps: null,
  isShowEntityDetail: false,
  currentGroundAlpha: 100,
  currentEntityBounds: null,
  currentEntityQuotaUrl: '',
  currentEntityStatInfo: null,
  serviceRelative: [],
}

const mutations = {
  changeEntityDetailVisible(state, flag) {
    state.isShowEntityDetail = flag;
  },
  addCurrentEntity(state, entity) {
    state.currentEntity = entity;
  },
  addCurrentEntityProps(state, entityProps) {
    state.currentEntityProps = entityProps;
  },
  toggleChildEntityActived(state, childEntity) {
    if (state.currentEntity && state.currentEntity.relateEntity) {
      let relateEntity = state.currentEntity.relateEntity;
      for (let i = 0; i < relateEntity.length; i++) {
        if (relateEntity[i].index == childEntity.index) {
          Vue.set(relateEntity[i], 'isActived', !relateEntity[i]['isActived']);
          break;
        }
      }
    }
  },
  changeGroundAlpha(state, alpha) {
    state.currentGroundAlpha = alpha;
  },
  changeCurrentEntityBounds(state, bounds) {
    state.currentEntityBounds = bounds;
  },
  changeCurrentEntityQuotaUrl(state, currentEntityQuotaUrl) {
    state.currentEntityQuotaUrl = currentEntityQuotaUrl;
  },
  changeCurrentEntityStatInfo(state, currentEntityStatInfo) {
    state.currentEntityStatInfo = currentEntityStatInfo;
  },
  changeServiceRelative(state, serviceRelative) {
    state.serviceRelative = serviceRelative;
  },
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/entity.js